<template>
  <footer :class="$style.footer">
    <div :class="$style.content">
      <a href="#main" :class="$style.name" @click.prevent="scrollTo('#main')">
        {{ $t("footer.name") }}
      </a>
      <div
        v-for="(group, groupName) in links"
        :key="groupName"
        :class="$style.links"
      >
        <a
          v-for="item in group"
          :key="item.text"
          :href="item.href || '#' + item.id"
          :target="item.href ? '_blank' : undefined"
          :rel="item.href ? 'noopener noreferrer' : undefined"
          :class="$style.link"
          @click="navigate($event, item)"
        >
          {{ item.text }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import dataEn from "../locales/en.json";
import dataPl from "../locales/pl.json";
import VueScrollTo from "vue-scrollto";
export default {
  data() {
    return {
      dataEn: dataEn.footer.links,
      dataPl: dataPl.footer.links,
      links: {
        first: [],
        second: [],
        third: [],
      },
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    if (this.$i18n.locale === "en") {
      this.links.first = this.dataEn.first;
      this.links.second = this.dataEn.second;
      this.links.third = this.dataEn.third;
    } else {
      this.links.first = this.dataPl.first;
      this.links.second = this.dataPl.second;
      this.links.third = this.dataPl.third;
    }
  },
  watch: {
    locale() {
      if (this.$i18n.locale === "en") {
        this.links.first = this.dataEn.first;
        this.links.second = this.dataEn.second;
        this.links.third = this.dataEn.third;
      } else {
        this.links.first = this.dataPl.first;
        this.links.second = this.dataPl.second;
        this.links.third = this.dataPl.third;
      }
    },
  },
  methods: {
    navigate(event, item) {
      if (item.href) {
        return;
      }

      event.preventDefault();
      this.scrollTo("#" + item.id);
    },
    scrollTo(component) {
      VueScrollTo.scrollTo(component, {
        offset: -50,
        duration: 500,
      });
    },
  },
};
</script>

<style lang="scss" module>
.footer {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../assets/images/footer.png");
  .content {
    max-width: 60rem;
    margin: 0 auto;
    padding: 6.25rem 1rem;
    position: relative;
    z-index: 2;
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 5rem;
    row-gap: 2rem;
    @include custom(840) {
      column-gap: 1rem;
    }
    @include custom(535) {
      padding: 3rem 1rem;
    }
    @include custom(470) {
      grid-template-columns: 1fr;
      gap: 0;
    }
    .name {
      grid-column: 1 / -1;
      color: $white;
      text-align: center;
      text-decoration: none;
      @include F36-600;
      @include custom(535) {
        margin-bottom: 1.5rem;
        font-size: 1.75rem;
      }
    }
    .links {
      .link {
        display: block;
        margin: 0 0 1rem 0;
        text-decoration: none;
        transition: all 0.3s ease-in-out;
        &:hover {
          color: $orange;
        }
        &:last-child {
          margin: 0;
        }
        cursor: pointer;
        color: $white;
        @include F28-500;
        @include custom(840) {
          font-size: 1.25rem;
        }
        @include custom(535) {
          font-size: 1.08rem;
        }
        @include custom(470) {
          text-align: center;
        }
      }
    }
  }
}
</style>
